// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "cce13edbbe8bd85b","396": "5c857e48989fe8a4","460": "7d951eccd9048099","917": "0eaa729c501ae347","985": "e4d9c757f3e66bc2",}[chunkId] + ".chunk.js"
}